import script from "./HelpTip.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpTip.vue?vue&type=script&setup=true&lang=js"

import "./HelpTip.vue?vue&type=style&index=0&id=5bb23a8e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bb23a8e"]])

export default __exports__